<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import polyBuilder from './functions/polyBuilder';
	import Fraction from './functions/fractionClass';

	export let uqn: number;

	let de: string, type: number, a: number, b: number, c: number;
	let initialM: string, steadyState: string;
	$: [de, initialM, steadyState] = uqnToQn(uqn);
	$: type = Number(uqn.toString()[0]);
	$: a = Number(uqn.toString()[1]);
	$: b = Number(uqn.toString()[2]);
	$: c = Number(uqn.toString()[3]);

	function uqnToQn(u:number):string[]{
		let [t,a,b,c] = uqnSplit(u);
		let bQn = (t<3 || t==4) ? new Fraction(b,1) : new Fraction(b, 10).simplify();
		let poly = t<3 ? polyBuilder([a,bQn.multiply(-1)],"m") : polyBuilder([bQn,-a],"m",1,false); 
		poly = "\\displaystyle \\frac{\\mathrm{d}m}{\\mathrm{d}t}=" + poly + ".";
		let iM = t%2==1? new Fraction(c,10).multiply(a).divide(bQn) : new Fraction(c+10,10).multiply(a).divide(bQn);
		let aOverB = new Fraction(a,1).divide(bQn);

		return [poly, iM.toString()+'.', aOverB.toString()];
	}
</script>

<p> 
	According to a model, the mass of bacteria,
	<Katex math={"m"}/>
	g in a test culture at time 
	<Katex math={"t"}/>
	s grows at a
	{#if type<3}
		constant rate of
		<Katex math={a.toString()}/>
		g/s and dies at a rate proportional to its current mass.
	{:else}
		rate proportional to its current mass and dies at a constant rate of
		<Katex math={a.toString()}/>
		g/s.
	{/if}
</p>

<p>
	It is given that the mass of bacteria stays constant if
	<Katex math={"m="+steadyState+"."}/>
</p>

<p class="qnpart">
	(a) Show that the mass of bacteria can be described by the differential equation
	<Katex math={de}/>
</p>
<p class="qnpart">
	(b) Find
	<Katex math="m"/>
	in terms of
	<Katex math="t"/>, given that the initial mass of bacteria is
	<Katex math={initialM}/>
</p>
<p class="qnpart">
	{#if type < 3}
	(c) State what happens to the mass of bacteria eventually.
	{:else if type==3}
	(c) Find the time when there is no bacteria left in the test culture.
	{:else}
	(c) By considering what happens in the long run, explain why this model is unrealistic.
	{/if}
</p>
<p class="qnpart">
(d) Sketch the graph of <Katex math="m"/> against <Katex math="t"/> for the parts relevant to
the context of the question.
</p>

<style>
/* 	.qnpart{
		margin-left: 1rem;
	} */
</style>